import { SVGProps, Ref, forwardRef } from 'react';

export const QuestionCircleFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 12C1 6.5 3.75 1 12 1s11 5.5 11 11-2.75 11-11 11S1 17.5 1 12m11-4.6c-1.12 0-1.85.706-1.85 1.6h-1.8c0-2.106 1.77-3.4 3.65-3.4s3.65 1.294 3.65 3.4c0 .812-.23 1.44-.61 1.946-.34.454-.779.773-1.101 1.007l-.035.025c-.362.263-.591.438-.754.656-.136.181-.25.428-.25.866h-1.8c0-.812.23-1.44.61-1.946.34-.454.779-.773 1.101-1.007l.035-.025c.362-.263.591-.438.754-.656.136-.181.25-.428.25-.866 0-.894-.73-1.6-1.85-1.6m0 7.6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
                fill="currentColor"
            />
        </g>
    </svg>
));
QuestionCircleFilledSize24Glyph.displayName = 'QuestionCircleFilledSize24Glyph';
